import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const InvoiceList = lazy(
    () => import("../components/InvoiceListContainer")
);

export const InvoiceDashboardRoute: RouteObject = {
  path: "invoice-dashboard",
  element: <InvoiceList />,
};

export default InvoiceDashboardRoute;